import {GetStaticPaths, GetStaticProps, GetStaticPropsContext} from 'next';

import {RENDER_MODES} from '@udemy/nextjs-core';

import {TermsPageFeature, TermsPageProps} from 'src/features/terms';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {AppContextData} from 'src/types/page-props';

import {TERM_PAGE_BASE_PATH} from '../../constants';
import {getStaticAppContext} from '../api/context.api';

export const getFullPageSlugToFetch = (slugs?: string[]) => {
    // 1. Check if slugs is undefined, then return /terms/
    if (!slugs) {
        return `/${TERM_PAGE_BASE_PATH}/`;
    }
    // 2. Check if slugs is an array with a length of 1 and the value is a legal page href.
    return `/${TERM_PAGE_BASE_PATH}/${slugs[0]}/`;
};

export const getStaticPaths: GetStaticPaths = () => {
    return {
        paths: [],
        fallback: 'blocking',
    };
};

export const getStaticProps: GetStaticProps = async (context: GetStaticPropsContext) => {
    const locale = context.locale as string;
    const translations = await getCompactTranslations(locale);

    // Resolve appContext
    const [staticData] = await Promise.all([getStaticAppContext({locale})]);
    const appContext: AppContextData = {
        ...staticData,
        // application specific context can go here
    };

    return {
        props: {
            appContext,
            locale,
            pageKey:
                Array.isArray(context.params?.slug) && context.params.slug.length > 0
                    ? `legal_terms_${context.params.slug[0]}`
                    : 'legal_terms',
            renderMode: RENDER_MODES.ISR, // supports render functions in _document.tsx and _app.tsx.
            translations,
        },
        revalidate: FOUR_HOURS,
    };
};

function Page(props: TermsPageProps) {
    return <TermsPageFeature {...props} />;
}

Page.getLayout = TermsPageFeature.getLayout;

export default Page;
